/**
 * Dynamic API Base URL resolver for Dinexa POS.
 * 
 * Precedence:
 * 1. process.env.REACT_APP_API_BASE_URL (if specified in .env / .env.production)
 * 2. Local development fallback (http://127.0.0.1:8000/api if on localhost/127.0.0.1)
 * 3. Live domain / Hostinger shared hosting dynamic fallback (`${window.location.protocol}//${window.location.hostname}/api`)
 */
export const getApiBaseUrl = () => {
    const { hostname, protocol } = window.location;

    // 1. Local development fallback (Connects Local React -> Hostinger Live API if no local PHP server)
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return process.env.REACT_APP_API_BASE_URL || 'https://dinexapos.esensevvg.online/api';
    }

    // 2. Dynamic Same-Origin resolver for Hostinger & Live Domains (${protocol}//${hostname}/api)
    // Ensures frontend always connects directly to the exact live host domain without hardcoded URL mismatches
    return `${protocol}//${hostname}/api`;
};

export const API_BASE_URL = getApiBaseUrl();
export default API_BASE_URL;
